import script from "./WizardBlindRegistCompleteStep.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardBlindRegistCompleteStep.vue?vue&type=script&setup=true&lang=js"

import "./WizardBlindRegistCompleteStep.vue?vue&type=style&index=0&id=7d22898c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d22898c"]])

export default __exports__